export const ROUTES = {
  // Auth routes
  LOGIN: {
    TITLE: "ورود مشاور",
    PATH: "/auth/login",
  },
  SIGNUP: {
    TITLE: "ثبت نام مشاور",
    PATH: "/auth/signup",
  },
  // ConsulteeApplicants
  CONSULTEE_APPLICANTS: {
    TITLE: "لیست کاربران",
    PATH: "/consultee-applicants",
  },
  CHAT: {
    TITLE: "گفتگو با کاربر",
    PATH: "/chat",
  },
  ACTIVE_PRODUCTS: {
    TITLE: "خدمات باقی‌مانده",
    PATH: "/active-products",
  },
  // iframes
  CONSULTANTS_USERS: {
    TITLE: "کاربران (نسخه قدیم)",
    PATH: "/consultants-users",
  },
  CRMEVENT_REQUEST: {
    TITLE: "سایر کارها",
    PATH: "/tinyCRMEvent-request",
  },
  ROUTINES: {
    TITLE: "روتین کاری",
    PATH: "/routine",
  },
  USER_PRODUCT: {
    TITLE: "کلاس‌ها و پروژه‌ها",
    PATH: "/user-product",
  },
  USER_RATES: {
    TITLE: "نظرات کاربران",
    PATH: "/user-rates",
  },
  CRMEVENT_REPORT: {
    TITLE: "گزارش ذی‌نغعان",
    PATH: "/TinyCRMReport",
  },

  PAYMENT_DETAILS: {
    TITLE: "جزيیات پرداخت",
    PATH: "/payment-details",
  },
  // Payment
  PAYMENT: {
    TITLE: "گزارش مالی",
    PATH: "/payment-report",
  },
  // others routes
  HOME: {
    TITLE: "خانه",
    PATH: "/home",
  },
  NOT_FOUND: {
    TITLE: "404",
    PATH: "/404",
  },
  CONSULTING: {
    TITLE: "مشاوره",
    PATH: "/consulting",
  },
  COUNSELING_FORM: {
    TITLE: "مشاوره",
    PATH: "/counseling-form",
  },
  DELETE_ACCOUNT: {
    TITLE: "حذف حساب کاربری",
    PATH: "/delete-account",
  },
};
